import React from 'react'
import { useIntl } from 'react-intl'
import WrapContext from './contexts/index'
import { WithCameraContext } from './contexts/cameraContext'
import { WithDeviceContext } from './contexts/deviceContext'
import { WithIMConnectionContext } from './contexts/imConnectionContext'
import { WithErrorContext } from './contexts/errorContext'
import { RouterContext } from './contexts/routerContext'

import { detectBrowserSupport } from './util/utilitys.js'

import SignIn from './containers/SignIn'
import Camera from './containers/Camera/Camera'
import CookieDialog from './components/CookieDialog'
import BuildNumber from './fronted-share-components/src/BuildNumber.js'
import MobileNotSupport from './fronted-share-components/src/MobileNotSupport.js'
import { buildNumber, version } from './constants/buildNumber.json'

import './styles/app.scss'
import { isDesktop } from './util/utilitys'

function App() {
    const [isOpenCookie, setIsOpenCookie] = React.useState(false)
    const routerContext = React.useContext(RouterContext)
    const intl = useIntl()

    React.useEffect(() => {
        function getCookie(name) {
            var i,
                x,
                y,
                ARRcookies = document.cookie.split(';')
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='))
                y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1)
                x = x.replace(/^\s+|\s+$/g, '')
                if (x === name) {
                    return decodeURI(y)
                }
            }
            return null
        }

        const isAgreeCookiePolicy = getCookie('isAgreeCookiePolicy') || false
        if (isAgreeCookiePolicy !== 'true' && isDesktop() === true) {
            // show cookie
            setIsOpenCookie(true)
        }
    }, [])

    if (isDesktop() === false) {
        const shareUrl =
            'https://alfred.camera/webapp/camera?utm_source=WebCamera&utm_medium=referral&utm_campaign=not_support_share'
        const shareTitle = intl.formatMessage({
            id: 'mobile_view_share_camera_title',
        })
        const shareText = intl.formatMessage({
            id: 'mobile_view_share_camera_text',
        })
        const description = intl.formatMessage({
            id: 'mobile_view_message',
        })
        return (
            <MobileNotSupport
                shareUrl={shareUrl}
                shareTitle={shareTitle}
                shareText={shareText}
                description={description}
                platform="webcamera"
            />
        )
    }

    let Component = <SignIn />
    if (routerContext.path === 'camera') {
        Component = WithErrorContext(
            WithCameraContext(
                WithDeviceContext(WithIMConnectionContext(Camera))
            )
        )()
    }

    return (
        <div>
            <WrapContext>
                <div className="App">{Component}</div>
            </WrapContext>
            {detectBrowserSupport() === true ? <CookieDialog /> : ''}
            <BuildNumber buildNumber={buildNumber} version={version} />
        </div>
    )
}

export default App
